import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface NfcWirelessIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * NFC Wireless icon using SF Pro font symbol (􀟜)
 *
 * This icon represents NFC wireless scanning/proximity communication,
 * used in the pairing help view to indicate NFC chip scanning.
 *
 * @example
 * ```tsx
 * <NfcWirelessIcon />
 * <NfcWirelessIcon size={16} weight="light" />
 * ```
 */
export const NfcWirelessIcon = React.forwardRef<HTMLSpanElement, NfcWirelessIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀟜" {...props} />
  }
)

NfcWirelessIcon.displayName = "NfcWirelessIcon"
